import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getSortedBlogPosts } from '../../content/blogPosts';
import useLangPrefix from '../../hooks/useLangPrefix';
import './Blog.css';

function BlogTeaser() {
  const { t, i18n } = useTranslation();
  const langPrefix = useLangPrefix();
  const posts = getSortedBlogPosts().slice(0, 3);

  if (posts.length === 0) return null;

  return (
    <section className="py-5 py-lg-6 bg-light border-top border-bottom" id="blog">
      <div className="container">
        <div className="row justify-content-center mb-4 mb-lg-5">
          <div className="col-lg-8 text-center">
            <h2 className="h3 fw-semibold text-navy mb-2">{t('blog.heading')}</h2>
            <p className="text-muted mb-0">{t('blog.subheading')}</p>
          </div>
        </div>
        <div className="row g-4 justify-content-center">
          {posts.map((post) => {
            const content = post[i18n.language] || post.ar;
            const dir = post[i18n.language] ? undefined : 'rtl';
            return (
              <div className="col-md-6 col-lg-4" key={post.slug}>
                <Link to={`${langPrefix}/blog/${post.slug}`} className="text-decoration-none">
                  <div className="card h-100 border-0 shadow-sm" dir={dir}>
                    <div className="card-body p-4">
                      <h3 className="h6 fw-semibold text-navy mb-3">{content.title}</h3>
                      <p className="card-text small text-muted mb-0">{content.metaDescription}</p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-4">
          <Link to={`${langPrefix}/blog`} className="link-navy text-decoration-none small">
            {t('blog.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  );
}

export default BlogTeaser;
